module.exports = __webpack_public_path__ + "img/Rogue.7918099c.png";